import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AnalyticsCupNav } from './components/AnalyticsCupNav';
import './AnalyticsCup.scss';
import submissionsCSV from '../../assets/analytics_cup/analytics-cup-26.csv';

const parseCSVLine = (line) => {
    const result = [];
    let current = '';
    let inQuotes = false;
    for (let i = 0; i < line.length; i++) {
        const ch = line[i];
        if (ch === '"') { inQuotes = !inQuotes; }
        else if (ch === ',' && !inQuotes) { result.push(current.trim()); current = ''; }
        else { current += ch; }
    }
    result.push(current.trim());
    return result;
};

const parseCSV = (text) =>
    text.trim().split('\n').slice(1).map(line => {
        const v = parseCSVLine(line);
        return {
            id: v[0], title: v[1], track: v[2], name: v[3],
            finalist: v[4] === 'TRUE',
            honourableMention: v[5] === 'TRUE',
            dataUsed: v[6], github: v[7],
        };
    });

const capitalizeName = (name = '') =>
    name.toLowerCase().split(' ')
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ').replace(/_/g, ' ');

export const AnalyticsCupResults = () => {
    const [submissions, setSubmissions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(submissionsCSV)
            .then(r => r.text())
            .then(text => { setSubmissions(parseCSV(text)); setLoading(false); })
            .catch(() => setLoading(false));
    }, []);

    const finalists        = submissions.filter(s => s.finalist);
    const honourableMentions = submissions.filter(s => s.honourableMention);

    const renderCard = (s, extra) => {
        const trackSlug = s.track === 'Research Track' ? 'research' : 'analyst';
        return (
            <div className={`ac-submission-card ac-submission-card--${trackSlug}`} key={s.id}>
                <div className="ac-submission-card__badges">
                    <span className="ac-submission-card__track">{s.track}</span>
                    {extra && (
                        <span className={`ac-submission-card__badge ac-submission-card__badge--${extra}`}>
                            {extra === 'finalist' ? 'Finalist' : 'Honourable Mention'}
                        </span>
                    )}
                </div>
                <h4 className="ac-submission-card__name">{capitalizeName(s.name)}</h4>
                <p className="ac-submission-card__title">
                    <a href={s.github} target="_blank" rel="noopener noreferrer">
                        {s.title}
                    </a>
                </p>
            </div>
        );
    };

    return (
        <div className="analytics-cup">
            <AnalyticsCupNav />

            <div className="ac-submissions-page">
                <div className="container">

                    <div className="ac-submissions-page__header">
                        <h1 className="ac-submissions-page__title">Edition 1.0 Results</h1>
                        <p className="ac-submissions-page__sub">
                            The first Analytics Cup culminated with an in-person final at SkillCorner HQ
                            in Paris on 5 February 2026. Six finalists presented their projects to a judging
                            panel and industry experts from top European clubs.
                        </p>
                        <Link to="/analytics-cup/submissions" className="ac-results__all-link">
                            View all submissions
                        </Link>
                    </div>

                    {loading ? (
                        <p className="ac-main__loading">Loading…</p>
                    ) : (
                        <>
                            <div className="ac-results__group">
                                <div className="ac-main__submissions-grid">
                                    {finalists.filter(s => s.name.toLowerCase().includes('amar')).map(s =>
                                        renderCard(s, 'finalist')
                                    )}
                                </div>
                            </div>

                            <div className="ac-results__group">
                                <div className="ac-main__submissions-grid">
                                    {finalists.filter(s => !s.name.toLowerCase().includes('amar')).map(s =>
                                        renderCard(s, 'finalist')
                                    )}
                                </div>
                            </div>

                            {honourableMentions.length > 0 && (
                                <div className="ac-results__group">
                                    <div className="ac-main__submissions-grid">
                                        {honourableMentions.map(s => renderCard(s, 'mention'))}
                                    </div>
                                </div>
                            )}
                        </>
                    )}

                </div>
            </div>
        </div>
    );
};
